import React, { Component } from "react";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "components/Snackbar/Snackbar.js";

export default class Notifications extends Component {
    constructor(props) {
        super(props);
        this.state = {notification: {show: this.props.notification.show, message: this.props.notification.message, type: this.props.notification.type}};
    }

    showNotification(message, type){
        this.setState({notification: {show: true, message: message, type: type}});
        setTimeout(() => {
        this.setState({notification: {show: false, message: '', type: 'info'}});
        }, 3000);
    }

    render() {
        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <Snackbar
                            place="bc"
                            color={this.state.notification.type}
                            icon={AddAlert}
                            message={this.state.notification.message}
                            open={this.state.notification.show}
                            closeNotification={() => this.setState({notification: {show: false, message: '', type: 'info'}})}
                            close
                        />
                    </GridItem>
                </GridContainer>
            </div>
        );
    };
}